module.exports = "<div class=\"container\">\n    <h1 style=\"margin: 50px 0 50px 0;font-size: 38px; text-align: center\">{{ displayProduct.name | lang }}</h1>\n    <div class=\"img-wrapper-slide-show\">\n        <img ng-src=\"{{ img_url + '/' + displayProduct.products_id }}\">\n    </div>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./slide_show/template/slide_show.html
 ** module id = 28
 ** module chunks = 0
 **/